<template>
  <div>
    <AlertLayout title="Reminders!"
      message="Kindly observe the facility's turn around time policy on received blood requisitions.<br>Click on Details button for more actions and information on the requisition of choice."
      type="warning" />
    <div class="flex flex-wrap items-center justify-between py-1 pb-4">
      <div class="flex items-center space-x-4">
        <div class="relative" v-if="currentTab === 'requisitions-made' || currentTab === 'patient-samples'">
          <button id="dropdownRadioButton"
            class="inline-flex items-center px-6 py-2 text-gray-400 bg-white border border-gray-300 rounded-md"
            type="button" @click="toggleDropdown">
            <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z" />
            </svg>
            Filters
            <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 4 4 4-4" />
            </svg>
          </button>
          <template v-if="currentTab === 'requisitions-made'">
            <div v-show="isDropdownOpen"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Date From</label>
                  <input type="date" v-model="filters.start_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Date To</label>
                  <input type="date" v-model="filters.end_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Status</label>
                  <select id="statusFilter" v-model="filters.status"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Pending">Pending</option>
                    <option value="Partially assigned">Partially assigned</option>
                    <option value="Partiall collected">Partiall collected</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>
          <template v-if="currentTab === 'patient-samples'">
            <div v-show="isDropdownOpen"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Date From</label>
                  <input type="date" v-model="filters.start_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Date To</label>
                  <input type="date" v-model="filters.end_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>
        </div>
      </div>
      <div class="flex items-center mt-4 space-x-4 sm:mt-0">
        <div class="relative flex">
          <template v-if="currentTab === 'requisitions-made'">
          <CustomButton label="Download" bg-class="bg-custom-yellow" @click="handleDownloadMadeRequisitions" />
        </template>
        <template v-if="currentTab === 'patient-samples'">
          <CustomButton label="Download" bg-class="bg-custom-yellow" @click="handleDownloadSampleReport" />
        </template>
        </div>
      </div>
      <div v-if="isPageLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="w-12 h-12 border-t-4 border-b-4 border-yellow-500 rounded-full animate-spin"></div>
      </div>
    </div>
    <div class="flex mb-4 border-b tabs">
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'dashboard' }" @click="currentTab = 'dashboard'">
        Dashboard
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'requisitions-made' }" @click="currentTab = 'requisitions-made'">
        Requisitions
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'patient-samples' }" @click="currentTab = 'patient-samples'">
        Patient Samples
      </button>
    </div>
    <component :is="currentTabComponent" ref="currentTabComponent" :search-query="searchQuery" :date-range="dateRange"></component>
  </div>
</template>

<script>
import AlertLayout from "@/components/AlertLayout.vue";
import CustomButton from "@/components/CustomButton.vue";
import RequisitionsMadeReportTab from "../tabs/RequisitionsMadeReportTab.vue";
import SampleReportsTab from "../tabs/SampleReportsTab.vue";
import UtilizationReportTab from "../tabs/UtilizationReportTab.vue";

export default {
  name: "RequisitionsReportsPage.",
  components: {
    AlertLayout,
    CustomButton,
    UtilizationReportTab,
    RequisitionsMadeReportTab,
    SampleReportsTab
  },
  
  data() {
    return {
      searchQuery: "",
      isDropdownOpen: false,
      currentTab: "dashboard",
      user: [],
      filters: {
        status: "",
        start_date: "",
        end_date: ""
      }
    };
  },
  created() {
    // Restore the currentTab from localStorage if it exists
    const savedTab = localStorage.getItem('requisitionReportsPageTab');
    if (savedTab && [
      'dashboard',
      'requisitions-made',
      'patient-samples'
    ].includes(savedTab)) {
      this.currentTab = savedTab;
    }
  },
  watch: {
    // Watch for changes to currentTab and save to localStorage
    currentTab(newTab) {
      localStorage.setItem('requisitionReportsPageTab', newTab);
    }
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "dashboard":
          return "UtilizationReportTab";
        case "requisitions-made":
          return "RequisitionsMadeReportTab";
        case "patient-samples":
          return "SampleReportsTab";
        default:
          return "UtilizationReportTab";
      }
    },
  },
  props: {},
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    hasManageClaim(value) {
      const claims = this.user?.user_roles?.[0]?.role?.claims || [];
      return claims.some((claim) => claim.name === value);
    },
    handleDownloadMadeRequisitions() {
      if (this.$refs.currentTabComponent?.handleDownloadMadeRequisitions) {
        this.$refs.currentTabComponent.handleDownloadMadeRequisitions();
      }
    },
    handleDownloadSampleReport() {
      if (this.$refs.currentTabComponent?.handleDownloadSampleReport) {
        this.$refs.currentTabComponent.handleDownloadSampleReport();
      }
    },
    applyFilters() {
      console.log('Applying filters:', this.filters);
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },

    applyFiltersToCurrentTab() {
      if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.applyFilters === 'function') {
        this.$refs.currentTabComponent.applyFilters(this.filters);
      } else {
        console.error('applyFilters method not found on current tab component');
      }
    },

    cancelFilters() {
      this.filters = {
        status: "",
        start_date: "",
        end_date: ""
      };
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },
  },
  mounted() {
    this.user = this.$store.getters["auth/user"];
  }
};
</script>

<style lang="css" scoped></style>